var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 475,
    viewBox: "0 0 458 475",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.5 38C337.622 38 435 135.826 435 256.5C435 377.174 337.622 475 217.5 475C97.3781 475 0 377.174 0 256.5C0 135.826 97.3781 38 217.5 38ZM217.5 116.461C140.456 116.461 78 179.159 78 256.5C78 333.841 140.456 396.539 217.5 396.539C294.544 396.539 357 333.841 357 256.5C357 179.159 294.544 116.461 217.5 116.461Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M367.904 75.2411C360.973 87.1585 361.551 103.379 362.706 110C373.795 71.5997 393.893 48.7582 402.556 42.1375L381.764 78.5515C406.021 81.862 428.545 52.0686 432.011 32.2064C434.783 16.3166 450.492 5.72341 458 2.41302C406.021 -9.17327 378.299 23.9304 367.904 38.8271C359.587 50.7444 364.439 68.0687 367.904 75.2411Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.bdf13ef546bdf0ec527be249faf9806c.svg";
export { ForwardRef as ReactComponent };